var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1614",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1618"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1628"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path1626"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1620",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1624",
    clipPath: "url(#clipPath1628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1630",
    transform: "translate(331.7529,94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.581,-26.333 13.158,-52.668 19.747,-79 h -185 c 6.422,25.666 12.837,51.333 19.252,77",
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1632"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1634",
    transform: "translate(140.1094,15.0005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 237.781",
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1636"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1638",
    transform: "translate(418,440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 48 c 8.25,0 15,-6.75 15,-15 v -316 c 0,-8.25 -6.75,-15 -15,-15 h -420 c -8.25,0 -15,6.75 -15,15 v 316 c 0,8.25 6.75,15 15,15 h 52",
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1642",
    transform: "translate(31,154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 450",
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1644"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 98,154 H 414 V 497 H 98 Z",
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1646"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1648",
    transform: "translate(158,274.0005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 15",
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1650"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1652",
    transform: "translate(233,274.0005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 120.997",
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1654"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1656",
    transform: "translate(158,214.0005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 15",
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1658"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1660",
    transform: "translate(233,214.0005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 120.997",
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1664",
    transform: "translate(279.9863,436.9995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -10.966,0 -20.322,-6.884 -23.986,-16.565 -27.651,-6.884 -37.008,0 -47.973,0 c -14.161,0 -25.641,-11.479 -25.641,-25.641 0,-20.902 39.23,-53.274 49.628,-59.276 15.009,8.666 49.627,38.374 49.627,59.276 C 25.641,-11.479 14.161,0 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1666"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.f44b29b1b163506a541ff1ced20a5f14.svg";
export { ForwardRef as ReactComponent };